"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Menu, X, Twitter } from "lucide-react"

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const navigate = useNavigate()

    const handleNavigation = (path) => {
        setIsMenuOpen(false)
        navigate(path)
    }

    return (
        <header className="bg-white bg-opacity-80 backdrop-blur-md shadow-md sticky top-0 z-50">
            <nav className="container mx-auto px-6 py-3">
                <div className="flex justify-between items-center">
                    <div className="flex items-center space-x-2 cursor-pointer" onClick={() => handleNavigation("/")}>
                        <Twitter className="w-8 h-8 text-indigo-600" />
                        <span className="text-2xl font-bold gradient-text">TweetInsight</span>
                    </div>
                    <div className="hidden md:flex space-x-6">
                        <span
                            onClick={() => handleNavigation("/")}
                            className="text-gray-700 hover:text-indigo-600 transition-colors duration-300 cursor-pointer"
                        >
                            Home
                        </span>
                        <span
                            onClick={() => handleNavigation("/dashboard")}
                            className="text-gray-700 hover:text-indigo-600 transition-colors duration-300 cursor-pointer"
                        >
                            Dashboard
                        </span>
                        <span
                            onClick={() => handleNavigation("/about")}
                            className="text-gray-700 hover:text-indigo-600 transition-colors duration-300 cursor-pointer"
                        >
                            About
                        </span>
                        <span
                            onClick={() => handleNavigation("/contact")}
                            className="text-gray-700 hover:text-indigo-600 transition-colors duration-300 cursor-pointer"
                        >
                            Contact
                        </span>
                    </div>
                    <button className="md:hidden focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>
                {isMenuOpen && (
                    <div className="md:hidden mt-4 space-y-2 py-2">
                        <span
                            onClick={() => handleNavigation("/")}
                            className="block text-gray-700 hover:text-indigo-600 transition-colors duration-300 cursor-pointer"
                        >
                            Home
                        </span>
                        <span
                            onClick={() => handleNavigation("/dashboard")}
                            className="block text-gray-700 hover:text-indigo-600 transition-colors duration-300 cursor-pointer"
                        >
                            Dashboard
                        </span>
                        <span
                            onClick={() => handleNavigation("/google-maps")}
                            className="block text-gray-700 hover:text-indigo-600 transition-colors duration-300 cursor-pointer"
                        >
                            Google Maps
                        </span>
                        <span
                            onClick={() => handleNavigation("/about")}
                            className="block text-gray-700 hover:text-indigo-600 transition-colors duration-300 cursor-pointer"
                        >
                            About
                        </span>
                        <span
                            onClick={() => handleNavigation("/contact")}
                            className="block text-gray-700 hover:text-indigo-600 transition-colors duration-300 cursor-pointer"
                        >
                            Contact
                        </span>
                    </div>
                )}
            </nav>
        </header>
    )
}
